import React from "react";
import { DatePicker } from "@ctsu/datepicker";
import { Controller } from "react-hook-form";
import FormErrorMessage from "./FormErrorMessage";

const getStyles = (rowPosition) => {
  let rowStyles = null;
  switch (rowPosition) {
    case false:
      rowStyles = {backgroundColor: 'transparent'};
      break;
    case true:
      rowStyles = {backgroundColor: 'hsl(0deg 0% 100% / 50%)'};
      break;
    case "first":
      rowStyles = {backgroundColor: 'hsl(0deg 0% 100% / 50%)', borderRadius: '4px 0 0 4px'};
      break;
    case "last":
      rowStyles = {backgroundColor: 'hsl(0deg 0% 100% / 50%)', borderRadius: '0 4px 4px 0'};
      break;
    default:
      break;
  }
  return rowStyles;
};

const FormDatePicker = ({
  name,
  label,
  hideLabel,
  labelHelp,
  labelClassName = "",
  wrapperClassName="",
  control,
  disabled = false,
  type = "text",
  required = false,
  minDate,
  maxDate,
  trigger,
  pickDateTime,
  onChangeCallback,
  editMode = true,
  rowPosition = false // false, true, first, last
}) => {
  return (
    <div className={`form-field ${wrapperClassName}`}>
      <label
        htmlFor={name}
        className={`form-label ${hideLabel ? "sr-only" : ""} ${labelClassName}`}
      >
        {required && (
          <span className="form-layout-required" aria-label="required">
            *
          </span>
        )}
        {label}
        {labelHelp && <span className="font-italic ml-1">{labelHelp}</span>}
      </label>
      <div
        className={`${rowPosition!==false ? 'px-2 pb-1' : ''}`}
        style={getStyles(rowPosition)}
      >
        <Controller
          name={name}
          control={control}
          render={({ field, fieldState }) => (
            <>
              {disabled || !editMode ? (
                // by default the datepicker sets dd-mmm-yyyy as value
                <input disabled id={name} type="text" value={field.value || ''} />
              ) : (
                <DatePicker
                  {...field}
                  id={name}
                  type={type}
                  disabled={disabled}
                  pickDateTime={pickDateTime}
                  onInputBlur={() => {
                    if (trigger) {
                      trigger(name);
                    }
                  }}
                  onChange={(e) => {
                    field.onChange(e);
                    if (trigger) {
                      trigger(name);
                    }
                    if (onChangeCallback) {
                      onChangeCallback(e);
                    }
                  }}
                  {...(minDate ? { fromDuration: minDate } : {})}
                  {...(maxDate ? { uptoDuration: maxDate } : {})}
                />
              )}
              {fieldState.error && (
                <FormErrorMessage message={fieldState.error.message} />
              )}
            </>
          )}
        />
      </div>
    </div>
  );
};

export default FormDatePicker;